import { gql } from '@apollo/client';

/**
 * 「更新换单确认扫描单号」外部员工版本。
 * 与 UPDATE_ORDER_REPRINT_CONFIRM 字段结构一致；用 GraphQL 别名保持响应字段名 `updateOrderReprintConfirm` 不变，
 * 下游可直接复用 UpdateOrderReprintConfirmResponse 类型。
 */
export const UPDATE_ORDER_REPRINT_CONFIRM_FOR_EXTERNAL_STAFF = gql`
    mutation UpdateOrderReprintConfirmForExternalStaff(
        $id: Long!
        $reprintTrackingNumber: String!
    ) {
        updateOrderReprintConfirm: updateOrderReprintConfirmForExternalStaff(
            id: $id
            reprintTrackingNumber: $reprintTrackingNumber
        )
    }
`;
